var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9677 0H2.03226C0.914516 0 0 0.9 0 2V13.3333C0 14.4333 0.914516 15.3333 2.03226 15.3333H7.1129V16.1333C6.87581 16.2333 6.23226 16.3333 5.41935 16.3333H4.74194V19H15.5806V16.3333H14.9032C14.1581 16.3333 13.4806 16.2333 13.2097 16.1333V15.3333H18.9677C20.0855 15.3333 21 14.4333 21 13.3333V2C21 0.9 20.0855 0 18.9677 0ZM14.2258 17.6667H6.09677V17.6333C7.65484 17.5333 8.46774 17.1 8.46774 16.3333V15.3333H11.8548V16.3333C11.8548 17.1 12.6677 17.5333 14.2258 17.6667ZM19.6452 13.3333C19.6452 13.7 19.3403 14 18.9677 14H2.03226C1.65968 14 1.35484 13.7 1.35484 13.3333V2C1.35484 1.63333 1.65968 1.33333 2.03226 1.33333H18.9677C19.3403 1.33333 19.6452 1.63333 19.6452 2V13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f802e9940e1762960fd7d38c292e0f49.svg";
export { ForwardRef as ReactComponent };